import { forwardRef } from "react";

import { InputStyled } from "./Input.styled";

export const Input = forwardRef(({ addStyles, ...rest }, ref) => {
  return (
    <InputStyled autoComplete="off" {...rest} ref={ref} addStyles={addStyles} />
  );
});
